export class AddReportDto {
    name!: string;
    spendPeriodId: string;
}